// authConfig.js — MSAL configuration for Entra ID

export const msalConfig = {
  auth: {
    clientId:    "0365af12-6ffb-436d-ad80-6220d1388889",
    authority:   "https://login.microsoftonline.com/394af1ed-0435-42e2-a82b-9a7fed4dc0d2",
    redirectUri: "https://admin.starlimsreporting.com/",
  },
  cache: {
    cacheLocation:          "localStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ["openid", "profile", "email"],
};
